module.exports = __webpack_public_path__ + "img/KVG_logo_header.4abc3918.svg";